export const systemSettingsRouteDef = [ 
    // {
    //     path:'custom_component',
    //     component:AppResourcePermissionComponent
    // }
    
]    